// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fG8A8","threshold":"styles_threshold__uQlXV"};